module.exports = __webpack_public_path__ + "static/media/bbva.fd930b09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pay-methods/bbva.png
// module id = 575
// module chunks = 0